var map = {
	"./CleverSaleVertical.svg": "944b",
	"./avatar-login.svg": "f774",
	"./bronze.svg": "a63e",
	"./calender_old.svg": "0e18",
	"./checkered_finish_flag.svg": "b9b5",
	"./clever-events/gold-trigger.svg": "847a",
	"./close.svg": "1d1b",
	"./compartilhar.svg": "1e52",
	"./conquest.svg": "de6a",
	"./eraser.svg": "2dfb",
	"./exclamação-azul.svg": "aa4b",
	"./exclamação-roxo.svg": "81c7",
	"./filter.svg": "c86e",
	"./fist-flag.svg": "5bd1",
	"./flag.svg": "ec96",
	"./funil.svg": "987f",
	"./geral.svg": "de4c",
	"./gold.svg": "fdb1",
	"./icon-bell.svg": "a014",
	"./icon-blue-check.svg": "1439",
	"./icon-button-conversation.svg": "be67",
	"./icon-button-details.svg": "9cb9",
	"./icon-calendar-round-bg.svg": "fcd8",
	"./icon-cancel.svg": "dab7",
	"./icon-conversation.svg": "c0ec4",
	"./icon-csat-heart-round-bg.svg": "dc4c",
	"./icon-details.svg": "1672",
	"./icon-funnel.svg": "1c0b",
	"./icon-graphic-chart-round-bg.svg": "b935",
	"./icon-green-check.svg": "fa33",
	"./icon-grid.svg": "9fb4",
	"./icon-journey-call.svg": "29e6",
	"./icon-journey-csat.svg": "e788",
	"./icon-journey-proposal.svg": "4f8e",
	"./icon-journey-whatsapp.svg": "c590",
	"./icon-magnifying-glass.svg": "a8ce",
	"./icon-menu-dots.svg": "1de7",
	"./icon-menu-leads.svg": "cfca",
	"./icon-menu-result.svg": "7aa4",
	"./icon-message.svg": "b6ca",
	"./icon-money-round-bg.svg": "77a1",
	"./icon-money.svg": "25b8",
	"./icon-nps-heart.svg": "b191",
	"./icon-right-arrow.svg": "46f1",
	"./icon-send.svg": "28a4",
	"./icon-smartphone.svg": "7fdc",
	"./icon-star-rating-outline.svg": "0b87",
	"./icon-star-rating.svg": "bd00",
	"./icon-total-conversions-bg.svg": "ce46",
	"./icon-transhipment-chat.svg": "5f5f",
	"./icon-upload.svg": "9237",
	"./icon_campaign_loudspeaker.svg": "4ed0",
	"./icone-smartphone.svg": "ae30",
	"./left-arrow-2.svg": "07f5",
	"./left-arrow.svg": "f330",
	"./ligapontos-dir.svg": "f0af",
	"./ligapontos-esq.svg": "dea5",
	"./login_bg2.svg": "0989",
	"./logo-hero-cinza.svg": "14e4",
	"./logo-hero.svg": "4445",
	"./logo-weclever-dark.svg": "0ff5",
	"./logo-weclever-light.svg": "3319",
	"./logo.svg": "1ae4",
	"./main/clever-insights-logo-component.svg": "8278",
	"./main/clever-insights-weclever-logo-component.svg": "8fc8",
	"./main/icons/icon-arrow-down-component.svg": "a17d",
	"./main/icons/icon-arrow-right-component.svg": "9c12",
	"./main/icons/icon-balloon-cross-component.svg": "92c6",
	"./main/icons/icon-bar-chart-component.svg": "7ed8",
	"./main/icons/icon-celebration-component.svg": "51a4",
	"./main/icons/icon-chart-growing-round-bars-bubble-component.svg": "b553",
	"./main/icons/icon-chat-bright-star-component.svg": "fe14",
	"./main/icons/icon-chat-component.svg": "9454",
	"./main/icons/icon-close-component.svg": "d0e1",
	"./main/icons/icon-cloud-upload-component.svg": "b4de",
	"./main/icons/icon-csat-heart-bubble-component.svg": "5650",
	"./main/icons/icon-csat-star-component.svg": "6222",
	"./main/icons/icon-custom-component.svg": "965e",
	"./main/icons/icon-dashboard-component.svg": "28da",
	"./main/icons/icon-demographic-profile-component.svg": "73f8",
	"./main/icons/icon-dislike-component.svg": "03e2",
	"./main/icons/icon-dollar-sign-bubble-component.svg": "ca79",
	"./main/icons/icon-expand-component.svg": "3e10",
	"./main/icons/icon-face-happy-component.svg": "aad6",
	"./main/icons/icon-face-neutral-component.svg": "4540",
	"./main/icons/icon-face-sad-component.svg": "7cfe",
	"./main/icons/icon-feeling-negative-component.svg": "e973",
	"./main/icons/icon-feeling-neutral-component.svg": "eb04",
	"./main/icons/icon-feeling-positive-component.svg": "adeb",
	"./main/icons/icon-filter-component.svg": "b75a",
	"./main/icons/icon-flag-component.svg": "5c96",
	"./main/icons/icon-flag-outline-component.svg": "666d",
	"./main/icons/icon-forum-component.svg": "3db4",
	"./main/icons/icon-groups-component.svg": "4d31",
	"./main/icons/icon-info-component.svg": "4114",
	"./main/icons/icon-insights-component.svg": "5862",
	"./main/icons/icon-leads-component.svg": "19bb",
	"./main/icons/icon-like-component.svg": "7199",
	"./main/icons/icon-list-exclamation-component.svg": "b6fa",
	"./main/icons/icon-list-x-component.svg": "0458",
	"./main/icons/icon-nav-business-insights-component.svg": "2cf5",
	"./main/icons/icon-nav-conversation-data-component.svg": "594c",
	"./main/icons/icon-nav-funnel-component.svg": "56bf",
	"./main/icons/icon-nav-leads-journey-component.svg": "dbe7",
	"./main/icons/icon-nav-leads-list-component.svg": "b57e",
	"./main/icons/icon-nav-leads-upload-component.svg": "c811",
	"./main/icons/icon-nav-overview-component.svg": "bc22",
	"./main/icons/icon-non-filter-component.svg": "6caf",
	"./main/icons/icon-person-search-component.svg": "2ac8",
	"./main/icons/icon-rating-star-component.svg": "ed9a",
	"./main/icons/icon-rating-star-outline-component.svg": "042c",
	"./main/icons/icon-result-component.svg": "568c",
	"./main/icons/icon-reviews-component.svg": "daf7",
	"./main/icons/icon-robot-component.svg": "f223",
	"./main/icons/icon-rounded-important-component.svg": "dbe3",
	"./main/icons/icon-running-with-errors-component.svg": "52ee",
	"./main/icons/icon-search-component.svg": "893a",
	"./main/icons/icon-search-data-component.svg": "4171",
	"./main/icons/icon-sparkles-component.svg": "41fa",
	"./main/icons/icon-star-component.svg": "1b36",
	"./main/icons/icon-star-outline-component.svg": "736c",
	"./main/icons/icon-stars-outline-component.svg": "065b",
	"./main/icons/icon-timeline-component.svg": "c42a",
	"./main/icons/icon-trashcan-component.svg": "b4d1",
	"./main/icons/icon-trending-down-component.svg": "a6e9",
	"./main/icons/icon-trending-up-component.svg": "4825",
	"./main/icons/icon-upload-component.svg": "73dc",
	"./main/icons/icon-variation-down.svg": "b9d2",
	"./main/icons/icon-variation-null.svg": "1846",
	"./main/icons/icon-variation-up.svg": "1521",
	"./main/icons/icon-variation-zero.svg": "d99b",
	"./main/icons/icon-world-component.svg": "c003",
	"./nps.svg": "1d06",
	"./off-view.svg": "0b49",
	"./on-view.svg": "807e",
	"./parenteses.svg": "3dc3",
	"./pencil.svg": "2d07",
	"./platform-avatar1.svg": "a3bc",
	"./platform-avatar2.svg": "d394",
	"./platform-circulo.svg": "18d5",
	"./platform-quadrado.svg": "36b8",
	"./platform-seta-selec.svg": "5694",
	"./qr-code-frame.svg": "24c5",
	"./sentiment_negative.svg": "78e2",
	"./sentiment_negative_grey.svg": "43a0",
	"./sentiment_negative_white.svg": "87dc",
	"./sentiment_neutral.svg": "d166",
	"./sentiment_neutral_grey.svg": "0f0a",
	"./sentiment_neutral_white.svg": "f36d",
	"./sentiment_positive.svg": "6aed",
	"./sentiment_positive_grey.svg": "4334",
	"./sentiment_positive_white.svg": "847c",
	"./silver.svg": "941b",
	"./squad-white.svg": "789b",
	"./squad.svg": "cd90",
	"./start.svg": "cf11",
	"./to-conquer.svg": "ef44",
	"./tooltip-question-mark.svg": "f410",
	"./total_conversion_values.svg": "227a",
	"./total_conversions.svg": "ab6e",
	"./total_lead_scheduled.svg": "cbd9",
	"./total_leads.svg": "4e95",
	"./total_leads_contacted.svg": "21a0",
	"./total_leads_queue.svg": "b392",
	"./total_leads_valid.svg": "13d7",
	"./total_leads_worked.svg": "3ca3",
	"./upload.svg": "c93a",
	"./vertical.svg": "e214",
	"./view_off.svg": "f48e",
	"./view_on.svg": "89a7",
	"./webcam.svg": "25f3",
	"./widget-csat/empty-stars.svg": "7558",
	"./widget-csat/star.svg": "5411"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";